import React, { useEffect, useState } from "react"
import axios from "axios"
import { useUI } from "../contexts/UIContext"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const FORM_VAZIO = {
  operadora_id:"", iccid:"", numero:"", apn:"", senha_apn:"",
  valor:"", dia_corte:"1", franquia_mb:"", alerta_consumo_pct:"80", observacoes:""
}

const fmtMB = (mb:any) => {
  if (!mb || parseFloat(mb)===0) return "—"
  const v = parseFloat(mb)
  if (v >= 1024) return `${(v/1024).toFixed(2)} GB`
  return `${v.toFixed(0)} MB`
}

const fmtMoeda = (v:any) => v ? `R$ ${parseFloat(v).toFixed(2).replace(".",",")}` : "—"

export default function Chips() {
  const { toast, confirm } = useUI()
  useEffect(()=>{
    if(!document.querySelector('#phosphor-bold')){
      const l=document.createElement('link');l.id='phosphor-bold';l.rel='stylesheet'
      l.href='https://unpkg.com/@phosphor-icons/web@2.1.1/src/bold/style.css'
      document.head.appendChild(l)
    }
  },[])
  const [dados, setDados]         = useState<any[]>([])
  const [operadoras, setOperadoras] = useState<any[]>([])
  const [modal, setModal]         = useState(false)
  const [editando, setEditando]   = useState<any>(null)
  const [form, setForm]           = useState<any>(FORM_VAZIO)
  const [busca, setBusca]         = useState("")
  const [loading, setLoading]     = useState(true)
  const [abaAtiva, setAbaAtiva]   = useState<"ativo"|"cancelado">("ativo")
  const [filtroOp, setFiltroOp]   = useState("")
  const [relatorio, setRelatorio] = useState(false)
  const [relFiltros, setRelFiltros] = useState({
    operadora_id:"", periodo_inicio:"", periodo_fim:"",
    inicio: new Date(Date.now()-30*24*60*60*1000).toISOString().split("T")[0],
    fim: new Date().toISOString().split("T")[0]
  })

  const carregar = async () => {
    try {
      const [ch, op] = await Promise.all([
        axios.get(`${API}/chips`),
        axios.get(`${API}/operadoras`)
      ])
      setDados(ch.data)
      setOperadoras(op.data)
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const abrirNovo = () => { setEditando(null); setForm(FORM_VAZIO); setModal(true) }
  const abrirEditar = (c:any) => {
    setEditando(c)
    setForm({
      operadora_id:c.operadora_id||"",
      iccid:c.iccid||"", numero:c.numero||"", apn:c.apn||"", senha_apn:c.senha_apn||"",
      valor:c.valor||"", dia_corte:c.dia_corte||"1",
      franquia_mb:c.franquia_mb||"", alerta_consumo_pct:c.alerta_consumo_pct||"80",
      observacoes:c.observacoes||""
    })
    setModal(true)
  }

  const salvar = async () => {
    if (!form.iccid) return alert("ICCID é obrigatório")
    if (!form.numero) return alert("Número da linha é obrigatório")
    if (!form.operadora_id) return alert("Operadora é obrigatória")
    try {
      if (editando) await axios.put(`${API}/chips/${editando.id}`, form)
      else await axios.post(`${API}/chips`, form)
      setModal(false); carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const cancelar = async (id:string) => {
    if (!window.confirm("Cancelar este chip?")) return
    try { await axios.put(`${API}/chips/${id}`,{status:"cancelado"}); carregar() } catch {}
  }

  const reativar = async (id:string) => {
    if (!window.confirm("Reativar este chip?")) return
    try { await axios.put(`${API}/chips/${id}`,{status:"ativo"}); carregar() } catch {}
  }

  const countAtivos = dados.filter(d=>d.status!=="cancelado").length
  const countCancelados = dados.filter(d=>d.status==="cancelado").length

  const filtrados = dados.filter(d => {
    if (abaAtiva==="ativo" && d.status==="cancelado") return false
    if (abaAtiva==="cancelado" && d.status!=="cancelado") return false
    if (filtroOp && d.operadora_id!==filtroOp) return false
    if (busca && !d.iccid?.includes(busca) && !d.numero?.includes(busca) &&
        !d.cliente_nome?.toLowerCase().includes(busca.toLowerCase())) return false
    return true
  })

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}><i className="ph-bold ph-sim-card" style={{marginRight:8}}/> Chips SIM</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} chip(s)</p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-ghost" onClick={()=>setRelatorio(!relatorio)}>
            <i className="ph-bold ph-chart-bar" style={{marginRight:6}}/>Relatório
          </button>
          <button className="btn btn-primary" onClick={abrirNovo}>+ Novo chip</button>
        </div>
      </div>

      {/* Abas */}
      <div style={{display:"flex",gap:0,marginBottom:16,borderBottom:"1px solid #2d4166"}}>
        {([["ativo","Habilitados",countAtivos],["cancelado","Cancelados",countCancelados]] as const).map(([id,label,count])=>(
          <button key={id} onClick={()=>setAbaAtiva(id)}
            style={{padding:"8px 20px",border:"none",background:"transparent",cursor:"pointer",
              fontFamily:"Inter",fontSize:13,fontWeight:abaAtiva===id?700:400,
              color:abaAtiva===id?(id==="ativo"?"#22c55e":"#f87171"):"#64748b",
              borderBottom:abaAtiva===id?`2px solid ${id==="ativo"?"#22c55e":"#f87171"}`:"2px solid transparent",
              marginBottom:-1}}>
            {label} <span style={{fontSize:11,color:"#475569",marginLeft:4}}>({count})</span>
          </button>
        ))}
      </div>

      {/* Relatório */}
      {relatorio && (
        <div className="card" style={{marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:12}}><i className="ph-bold ph-chart-bar" style={{marginRight:6}}/>Relatório de consumo</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:12,alignItems:"end"}}>
            <div className="form-group" style={{margin:0}}>
              <label>Operadora</label>
              <select value={relFiltros.operadora_id} onChange={e=>setRelFiltros({...relFiltros,operadora_id:e.target.value})}>
                <option value="">Todas</option>
                {operadoras.map((o:any)=><option key={o.id} value={o.id}>{o.nome}</option>)}
              </select>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label>Data início</label>
              <input type="date" value={relFiltros.inicio} onChange={e=>setRelFiltros({...relFiltros,inicio:e.target.value})} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label>Data fim</label>
              <input type="date" value={relFiltros.fim} onChange={e=>setRelFiltros({...relFiltros,fim:e.target.value})} />
            </div>
            <button className="btn btn-primary">📥 Gerar</button>
          </div>

          {/* Cards resumo */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginTop:16}}>
            {[
              {label:"Total chips ativos", valor:countAtivos, cor:"#22c55e", icone:"sim-card"},
              {label:"Consumo total", valor:fmtMB(dados.reduce((s:number,d:any)=>s+parseFloat(d.consumo_atual_mb||0),0)), cor:"#0ea5e9", icone:"broadcast"},
              {label:"Custo mensal", valor:fmtMoeda(dados.filter(d=>d.status!=="cancelado").reduce((s:number,d:any)=>s+parseFloat(d.valor||0),0)), cor:"#f59e0b", icone:"currency-dollar"},
              {label:"Alertas consumo", valor:dados.filter(d=>d.franquia_mb&&d.consumo_atual_mb&&(parseFloat(d.consumo_atual_mb)/parseFloat(d.franquia_mb)*100)>=(d.alerta_consumo_pct||80)).length, cor:"#f87171", icone:"warning"},
            ].map((s,i)=>(
              <div key={i} style={{background:"#0d1b2e",borderRadius:8,padding:"12px 14px"}}>
                <div style={{fontSize:18,marginBottom:4}}>{s.icone}</div>
                <div style={{fontSize:16,fontWeight:700,color:s.cor}}>{s.valor}</div>
                <div style={{fontSize:10,color:"#64748b"}}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Filtros */}
      <div style={{display:"flex",gap:12,marginBottom:16}}>
        <input placeholder="Buscar ICCID, número ou cliente..." value={busca}
          onChange={e=>setBusca(e.target.value)} style={{flex:1,maxWidth:350}} />
        <select value={filtroOp} onChange={e=>setFiltroOp(e.target.value)} style={{minWidth:150}}>
          <option value="">Todas operadoras</option>
          {operadoras.map((o:any)=><option key={o.id} value={o.id}>{o.nome}</option>)}
        </select>
      </div>

      {/* Tabela */}
      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["ICCID","Número","Operadora","Cliente","Rastreador","Ativo","Franquia","Consumo","Valor","Corte","Status","Ações"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={12} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : filtrados.length===0 ? (
              <tr><td colSpan={12} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum chip encontrado</td></tr>
            ) : filtrados.map((ch:any)=>{
              const pct = ch.franquia_mb && ch.consumo_atual_mb
                ? Math.min(100, parseFloat(ch.consumo_atual_mb)/parseFloat(ch.franquia_mb)*100)
                : 0
              const alerta = pct >= (ch.alerta_consumo_pct||80)
              return (
                <tr key={ch.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                  <td style={{padding:"10px 12px",fontSize:11,fontFamily:"monospace"}}>{ch.iccid}</td>
                  <td style={{padding:"10px 12px",fontSize:12}}>{ch.numero||"—"}</td>
                  <td style={{padding:"10px 12px",fontSize:12,color:"#94a3b8"}}>{ch.operadora_nome||"—"}</td>
                  <td style={{padding:"10px 12px",fontSize:12}}>{ch.cliente_nome||"—"}</td>
                  <td style={{padding:"10px 12px",fontSize:11}}>
                    {ch.rastreador_imei ? (
                      <div>
                        <div style={{color:"#38bdf8",fontSize:11}}>{ch.rastreador_imei}</div>
                        {ch.ativo_nome && <div style={{fontSize:10,color:"#64748b"}}>{ch.ativo_nome}{ch.placa?` (${ch.placa})`:""}</div>}
                      </div>
                    ) : <span style={{color:"#475569"}}>Sem vínculo</span>}
                  </td>
                  <td style={{padding:"10px 12px",fontSize:11,color:"#64748b"}}>{ch.ativo_nome||"—"}</td>
                  <td style={{padding:"10px 12px",fontSize:11}}>{fmtMB(ch.franquia_mb)}</td>
                  <td style={{padding:"10px 12px"}}>
                    {ch.franquia_mb ? (
                      <div>
                        <div style={{fontSize:11,color:alerta?"#f87171":"#94a3b8",fontWeight:alerta?700:400}}>
                          {fmtMB(ch.consumo_atual_mb)} {alerta&&<i className="ph-bold ph-warning" style={{color:"#f59e0b",fontSize:12,marginLeft:3}}/>}
                        </div>
                        <div style={{width:80,height:4,background:"#1e2f4a",borderRadius:2,marginTop:3}}>
                          <div style={{width:`${pct}%`,height:4,borderRadius:2,
                            background:pct>=90?"#f87171":pct>=70?"#f59e0b":"#22c55e"}} />
                        </div>
                        <div style={{fontSize:9,color:"#475569",marginTop:1}}>{pct.toFixed(0)}%</div>
                      </div>
                    ) : <span style={{fontSize:11,color:"#475569"}}>—</span>}
                  </td>
                  <td style={{padding:"10px 12px",fontSize:12,color:"#22c55e"}}>{fmtMoeda(ch.valor)}</td>
                  <td style={{padding:"10px 12px",fontSize:12,color:"#94a3b8"}}>Dia {ch.dia_corte||1}</td>
                  <td style={{padding:"10px 12px"}}>
                    <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                      background:ch.status==="cancelado"?"#450a0a":"#14532d",
                      color:ch.status==="cancelado"?"#f87171":"#4ade80"}}>
                      {ch.status==="cancelado"?"Cancelado":"Ativo"}
                    </span>
                  </td>
                  <td style={{padding:"10px 12px"}}>
                    <div style={{display:"flex",gap:4}}>
                      <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11}}
                        onClick={()=>abrirEditar(ch)}><i className="ph-bold ph-pencil-simple" style={{fontSize:13}}/></button>
                      {ch.status!=="cancelado" ? (
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#f87171"}}
                          onClick={()=>cancelar(ch.id)}><i className="ph-bold ph-x-circle" style={{fontSize:13}}/></button>
                      ) : (
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#4ade80"}}
                          onClick={()=>reativar(ch.id)}><i className="ph-bold ph-check-circle" style={{fontSize:13}}/></button>
                      )}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:560,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h3>{editando ? <><i className="ph-bold ph-pencil-simple" style={{marginRight:6}}/>Editar chip</> : <><i className="ph-bold ph-sim-card" style={{marginRight:6}}/>Novo chip SIM</>}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>

            <div className="form-grid">
              <div className="form-group full">
                <label>ICCID *</label>
                <input value={form.iccid} onChange={e=>setForm({...form,iccid:e.target.value})}
                  placeholder="89550000000000000000" style={{fontFamily:"monospace"}} />
              </div>
              <div className="form-group">
                <label>Número da linha *</label>
                <input value={form.numero} onChange={e=>setForm({...form,numero:e.target.value})}
                  placeholder="(00) 00000-0000" />
              </div>
              <div className="form-group">
                <label>Operadora *</label>
                <select value={form.operadora_id} onChange={e=>setForm({...form,operadora_id:e.target.value})}>
                  <option value="">— Selecione —</option>
                  {operadoras.map((o:any)=><option key={o.id} value={o.id}>{o.nome}</option>)}
                </select>
              </div>

              <div className="form-group full" style={{gridColumn:"1/-1",borderTop:"1px solid #2d4166",paddingTop:12,marginTop:4}}>
                <div style={{fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:8}}>🔐 Configuração APN</div>
              </div>
              <div className="form-group">
                <label>APN</label>
                <input value={form.apn} onChange={e=>setForm({...form,apn:e.target.value})}
                  placeholder="internet.operadora.com.br" />
              </div>
              <div className="form-group">
                <label>Senha APN</label>
                <input value={form.senha_apn} onChange={e=>setForm({...form,senha_apn:e.target.value})}
                  placeholder="Senha da APN" />
              </div>
              <div className="form-group">
                <label><i className="ph-bold ph-currency-dollar" style={{marginRight:4}}/>Valor mensal (R$)</label>
                <input type="number" value={form.valor} step="0.01" min="0"
                  onChange={e=>setForm({...form,valor:e.target.value})} placeholder="0,00" />
              </div>
              <div className="form-group">
                <label>📅 Dia de corte</label>
                <select value={form.dia_corte} onChange={e=>setForm({...form,dia_corte:e.target.value})}>
                  {Array.from({length:28},(_,i)=>i+1).map(d=>(
                    <option key={d} value={d}>Dia {d}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label><i className="ph-bold ph-broadcast" style={{marginRight:4}}/>Franquia (MB/GB)</label>
                <div style={{display:"flex",gap:8}}>
                  <input type="number" value={form.franquia_mb} min="0"
                    onChange={e=>setForm({...form,franquia_mb:e.target.value})} placeholder="Ex: 1024" style={{flex:1}} />
                  <select style={{width:70}} onChange={e=>{
                    if(e.target.value==="GB" && form.franquia_mb)
                      setForm({...form,franquia_mb:String(parseFloat(form.franquia_mb)*1024)})
                    if(e.target.value==="MB" && form.franquia_mb)
                      setForm({...form,franquia_mb:String(parseFloat(form.franquia_mb)/1024)})
                  }}>
                    <option value="MB">MB</option>
                    <option value="GB">GB</option>
                  </select>
                </div>
                <div style={{fontSize:10,color:"#475569",marginTop:3}}>
                  {form.franquia_mb ? fmtMB(form.franquia_mb) : ""}
                </div>
              </div>
              <div className="form-group">
                <label><i className="ph-bold ph-warning" style={{marginRight:4}}/>Alerta de consumo (%)</label>
                <input type="number" value={form.alerta_consumo_pct} min="1" max="100"
                  onChange={e=>setForm({...form,alerta_consumo_pct:e.target.value})} />
                <div style={{fontSize:10,color:"#475569",marginTop:3}}>
                  Notificar quando atingir {form.alerta_consumo_pct}% da franquia
                </div>
              </div>
              <div className="form-group full">
                <label>Observações</label>
                <input value={form.observacoes} onChange={e=>setForm({...form,observacoes:e.target.value})}
                  placeholder="Observações adicionais..." />
              </div>
            </div>

            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>💾 Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
